import React from 'react';

import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import { SubNavWrapper, SubNavButton } from './css';
import { useLocalizedStringsContext } from '../../../../context/LocalizedStringsContext';
import { useLocaleContext } from '../../../../context/LocaleContext';
import EN from '../../../../../EN.json';
import FR from '../../../../../FR.json';
const Navigation = ({ selectedDashboard }) => {
  const local = useLocaleContext()

  const {
  DEFECT_MANAGEMENT: { manageControlTabs } }
  = local === 'en-US' ? EN : FR;
  const history = useHistory();
  

  return (
    <SubNavWrapper>
      {manageControlTabs.map(({ key, label }) => (
        <div>
        <SubNavButton
          isSelected={selectedDashboard === key}
          onClick={() => history.push(`/manage-control/${key}`)}
        >
          {label}
        </SubNavButton>
      </div>
      ))}
    </SubNavWrapper>
  );
};

Navigation.propTypes = {
  selectedDashboard: PropTypes.string.isRequired
};

export default Navigation;
